import {
    ACTION_LIST_USERSADMIN,
    SET_USERSADMIN,

    ACTION_DELETE_USERSADMIN,

    ACTION_POST_CREATE_USERSADMIN,

    ACTION_PUT_UPDATE_USERSADMIN,
    ACTION_GET_USERSADMIN_ID,
    SET_USER_ADMIN_ID,

    ACTION_GET_USERSADMIN_LIST_TYPE_DOCUMENT,
    SET_USERADMIN_LIST_TYPE_DOCUMENT,

    ACTION_GET_USERSADMIN_LIST_TYPE_ROL,
    SET_USERADMIN_LIST_TYPE_ROL,

    ACTION_GET_USERSADMIN_COMPANY_ID,
    SET_USER_ADMIN_COMPANY_ID,

    ACTION_PUT_UPDATE_USERSADMIN_COMPANY_ID,

    ACTION_POST_CREATE_CARGUE_EXCEL,

    ACTION_GET_AFFILIATEDUSERS_LIST_GENDER,
    SET_AFFILIATEDUSERS_LIST_GENDER,

    ACTION_GET_STARASSIGNMENT_SEARCHAFFILIATES,
    SET_STARASSIGNMENT_SEARCHAFFILIATES,

    ACTION_GET_USERSTATUS,
    SET_USERSTATUS,

    ACTION_POST_USERSTATUS

} from "@/views/users_admin/store/types/types.js";

import Swal from 'sweetalert2';
import EventBus from '@/utils/event_bus.js';
import { userAdminService } from "../../../services";

const actions = {

    [ACTION_LIST_USERSADMIN]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loadingUser = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                userAdminService.getUserAdmin(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data && Array.isArray(resp.data.payload)) {
                            const users = resp.data.payload.map((user, i) => ({
                                ...user,
                                activeDialogClient: false,
                                index: i
                            }));

                            // Commit a la mutación para actualizar el estado con la lista de usuarios
                            commit(SET_USERSADMIN, users);
                            resolve(resp.data);
                        } else {
                            console.error("La respuesta no tiene un formato esperado:", resp);
                            reject("La respuesta no tiene un formato esperado");
                        }
                    })
                    .catch(err => {
                        console.error("Error en la solicitud de modos:", err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loadingUser = false;
                    });
            } catch (error) {
                console.error("Error en la solicitud de modos:", error);
                reject(error);
            }
        });
    },

    [ACTION_DELETE_USERSADMIN]: async ({ state }, userId) => {

        const resp = await new Promise((resolve, reject) => {
            state.loadingUser = true;

            const idGroup = sessionStorage.getItem("idGroup");
            const idEmpresa = sessionStorage.getItem("idEmpresa");
            const idUsuario = sessionStorage.getItem("idUsuario");

            userAdminService.getUserAdminDelete(idGroup, idEmpresa, idUsuario, userId).then(resp => {

                EventBus.$emit('reload-delete-userAdmin');
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'El usuario ha sido eliminado exitosamente',
                    showConfirmButton: false,
                    timer: 2500
                });
                resolve(resp);
            })
                .catch(err => {
                    reject(err);
                })

                .finally(() => {
                    state.loadingUser = false;
                });
        });

        return resp;
    },

    [ACTION_POST_CREATE_USERSADMIN]: ({ state }, usersAdmin) => {
        return new Promise((resolve, reject) => {
            try {
                state.loadingUser = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                if (!usersAdmin.companyId) {
                    usersAdmin.companyId = idEmpresa;
                }
                userAdminService.postUserAdminCreate({ idGroup, idEmpresa, idUsuario, usersAdmin })
                    .then(async response => {
                        await Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: 'El usuario fue creado exitosamente',
                            showConfirmButton: false,
                            timer: 2500
                        });
                        EventBus.$emit('reload-update-usersAdmin');
                        resolve(response.data);
                    })
                    .catch(error => {
                        console.error("Error en la solicitud:", error);
                        reject(error);
                    })
                    .finally(() => {
                        state.loadingUser = false;
                    });
            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },


    [ACTION_GET_USERSADMIN_LIST_TYPE_DOCUMENT]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loadingUser = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                userAdminService.getUserAdminTypDocument(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const typeUsersAdmin = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_USERADMIN_LIST_TYPE_DOCUMENT, typeUsersAdmin);
                            resolve(resp.data.payload);

                        } else {
                            console.error("La respuesta no tiene un formato esperado:", resp);
                            reject("La respuesta no tiene un formato esperado");
                        }
                    })
                    .catch(err => {
                        console.error("Error en la solicitud de tipo documento:", err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loadingUser = false;
                    });
            } catch (error) {
                console.error("Error en la solicitud de tipo documento:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_USERSADMIN_LIST_TYPE_ROL]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loadingUser = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                userAdminService.getUserAdminTypeRol(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const typeUsersAdminRol = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_USERADMIN_LIST_TYPE_ROL, typeUsersAdminRol);
                            resolve(resp.data.payload);

                        } else {
                            console.error("La respuesta no tiene un formato esperado:", resp);
                            reject("La respuesta no tiene un formato esperado");
                        }
                    })
                    .catch(err => {
                        console.error("Error en la solicitud de tipo documento:", err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loadingUser = false;
                    });
            } catch (error) {
                console.error("Error en la solicitud de tipo documento:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_USERSADMIN_ID]: async ({ state, commit }, userAdmin) => {


        return await new Promise((resolve, reject) => {

            state.loadingUser = true;

            const idGroup = sessionStorage.getItem("idGroup");
            const idEmpresa = sessionStorage.getItem("idEmpresa");
            const idUsuario = sessionStorage.getItem("idUsuario");

            userAdminService.getUserAdminId(idGroup, idEmpresa, idUsuario, userAdmin)
                .then(resp => {

                    const userAdminid = resp.data.payload
                    commit(SET_USER_ADMIN_ID, userAdminid);
                    resolve(resp.data.payload);

                })
                .catch(err => {
                    console.error("Error en la solicitud de usuario:", err);
                    reject(err);
                })
                .finally(() => {
                    state.loadingUser = false;
                });
        })
    },

    [ACTION_PUT_UPDATE_USERSADMIN]: async ({ state }, usersAdmin) => {

        return await new Promise((resolve, reject) => {

            state.loadingUser = true;
            const idGroup = sessionStorage.getItem("idGroup");
            const idEmpresa = sessionStorage.getItem("idEmpresa");
            const idUsuario = sessionStorage.getItem("idUsuario");

            userAdminService.upDateUserAdmin({ idGroup, idEmpresa, idUsuario, usersAdmin })
                .then(async (resp) => {
                    await Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: 'El usuario fue actualizado exitosamente',
                        showConfirmButton: false,
                        timer: 2500
                    });

                    resolve(resp);
                    window.location.reload();
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loadingUser = false);
        });
    },

    [ACTION_GET_USERSADMIN_COMPANY_ID]: async ({ state, commit }, companyId) => {

        return await new Promise((resolve, reject) => {

            state.loadingUser = true;

            const idGroup = sessionStorage.getItem("idGroup");
            const idEmpresa = sessionStorage.getItem("idEmpresa");
            const idUsuario = sessionStorage.getItem("idUsuario");

            userAdminService.getUserAdminCompanyId(idGroup, idEmpresa, idUsuario, companyId)
                .then(resp => {
                    const userAdminCompanyId = resp.data.payload
                    commit(SET_USER_ADMIN_COMPANY_ID, userAdminCompanyId);
                    resolve(resp.data.payload);

                })
                .catch(err => {
                    console.error("Error en la solicitud de usuario:", err);
                    reject(err);
                })
                .finally(() => {
                    state.loadingUser = false;
                });
        })
    },

    [ACTION_PUT_UPDATE_USERSADMIN_COMPANY_ID]: async ({ state }, usersAdmin) => {

        return await new Promise((resolve, reject) => {

            state.loadingUser = true;
            const idGroup = sessionStorage.getItem("idGroup");
            const idEmpresa = sessionStorage.getItem("idEmpresa");
            const idUsuario = sessionStorage.getItem("idUsuario");

            userAdminService.upDateUserAdminCompanyId({ idGroup, idEmpresa, idUsuario, usersAdmin })
                .then(async resp => {
                    if (resp.data.payload) {
                        await Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: 'El usuario fue actualizado exitosamente',
                            showConfirmButton: false,
                            timer: 2500

                        });

                        resolve(resp.data.payload);
                    } else {
                        console.error("La respuesta no tiene un formato esperado:", resp);
                        reject("La respuesta no tiene un formato esperado");
                    }
                })

                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loadingUser = false);
        });
    },

    [ACTION_POST_CREATE_CARGUE_EXCEL]: async ({ state }, excelFile) => {
        try {
            state.loadingUser = true;

            const idGroup = sessionStorage.getItem("idGroup");
            const idEmpresa = sessionStorage.getItem("idEmpresa");
            const idUsuario = sessionStorage.getItem("idUsuario");
            Swal.fire({
                title: 'Cargando archivo...',
                text: 'Por favor, espera un momento.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showloadingUser();
                }
            });
            userAdminService.postCargueAffiliatedUser(idGroup, idEmpresa, idUsuario, excelFile)
                .then(response => {
                    if (response.status === 200) {
                        Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: response.data.payload,
                            showConfirmButton: false,
                            timer: 3000
                        }).then(() => {
                            setTimeout(() => {
                                window.location.reload();
                            }, 0);
                        });
                        return response.data;
                    } if (response.status === 206) {
                        Swal.fire({
                            position: 'top-end',
                            icon: 'warning',
                            title: response.data.payload,
                            showConfirmButton: false,
                            timer: 3000
                        }).then(() => {
                            setTimeout(() => {
                                window.location.reload();
                            }, 0);
                        });
                        return response.data;
                    }
                    else {
                        console.error("La petición fue incorrecta o falló");
                        return Promise.reject("La petición fue incorrecta o falló");
                    }
                }
                )
        } catch (error) {
            console.error("Error en la solicitud:", error);
            return Promise.reject(error);
        } finally {
            state.loadingUser = false;
        }
    },


    [ACTION_GET_AFFILIATEDUSERS_LIST_GENDER]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loadingUser = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                userAdminService.getAffiliatedGender(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const genderAffiliated = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_AFFILIATEDUSERS_LIST_GENDER, genderAffiliated);
                            resolve(resp.data.payload);

                        } else {
                            console.error("La respuesta no tiene un formato esperado:", resp);
                            reject("La respuesta no tiene un formato esperado");
                        }
                    })
                    .catch(err => {
                        console.error("Error en la solicitud de tipo documento:", err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loadingUser = false;
                    });
            } catch (error) {
                console.error("Error en la solicitud de tipo documento:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_STARASSIGNMENT_SEARCHAFFILIATES]: async ({ state, commit }, searchTerm) => {
        return new Promise((resolve, reject) => {
            try {
                state.loadingUser = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                userAdminService.getSearchAffiliate(idGroup, idEmpresa, idUsuario, searchTerm)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const searchAffiliates = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_STARASSIGNMENT_SEARCHAFFILIATES, searchAffiliates);
                            resolve(resp.data.payload);

                        } else {
                            console.error("La respuesta no tiene un formato esperado:", resp);
                            reject("La respuesta no tiene un formato esperado");
                        }
                    })
                    .catch(err => {
                        console.error("Error en la solicitud de tipo documento:", err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loadingUser = false;
                    });
            } catch (error) {
                console.error("Error en la solicitud de tipo documento:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_USERSTATUS]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loadingUser = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                userAdminService.getUserStatus(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const userStatus = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_USERSTATUS, userStatus);
                            resolve(resp.data.payload);

                        } else {
                            console.error("La respuesta no tiene un formato esperado:", resp);
                            reject("La respuesta no tiene un formato esperado");
                        }
                    })
                    .catch(err => {
                        console.error("Error en la solicitud de tipo documento:", err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loadingUser = false;
                    });
            } catch (error) {
                console.error("Error en la solicitud de tipo documento:", error);
                reject(error);
            }
        });
    },
    [ACTION_POST_USERSTATUS]: ({ state }, data) => {
        return new Promise((resolve, reject) => {
            try {
                state.loadingUser = true;
                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                userAdminService.postUserStatus({ idGroup, idEmpresa, idUsuario, data})
                    .then(async response => {
                        await Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: response.data.payload,
                            showConfirmButton: false,
                            timer: 2500
                        });
                        EventBus.$emit('reload-update');
                        resolve(response.data);
                        window.location.reload();
                    })
                    .catch(error => {
                        console.error("Error en la solicitud:", error);
                        reject(error)
                    })
                    .finally(() => {
                        state.loadingUser = false;
                    });
            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },
}

export default actions;